import AllasLogo from '@/allas/public/image/allas-logo.svg';
import { ArticlePaywall } from '@/components/ArticlePaywall';
import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { useStable } from '@/hooks/useStable';
import useUserAuth from '@/hooks/useUserAuth';
import { mergeProps } from '@/utils/merge';
import { StandaloneContentLock } from 'base/components/ContentLock';
import { usePathname } from 'next/navigation';
import { useMemo, useRef } from 'react';

export const AllasStandaloneContentLock: typeof StandaloneContentLock = (props) => {
  const { logInUrl, signUpUrl } = useUserAuth();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const pathname = usePathname();

  const headline = useMemo(
    () => (
      <>
        Vill du läsa hela artikeln?
        <br />
        Skapa ett konto på Allas – helt gratis!
      </>
    ),
    [],
  );

  const content = useStable({
    purchase: <ArticlePaywall paymentMethod={'frisbii'} />,
    login: pathname.startsWith('/korsord-och-spel') ? (
      <dialog
        ref={dialogRef}
        className={
          'not-prose bg-logga-300 left-1/2 top-[40vh] m-0 flex max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-y-6 overflow-auto px-4 pb-8 pt-20 text-center shadow-[0px_0px_14px_rgba(0,0,0,0.25)] outline-none sm:px-7 md:max-w-2xl [&::backdrop]:backdrop-blur'
        }
      >
        <AllasLogo className="absolute left-1/2 top-4 w-28 -translate-x-1/2" />
        <h3 className="text-center !font-normal text-headline-sm">Logga in för att lösa korsord och spela våra spel</h3>
        <p className="text-center text-paragraph-md">
          Våra roliga spel, kryss och sudokus får du tillgång till genom att logga in på allas.se, helt gratis!
        </p>
        <Button content="Logga in" href={logInUrl} options={{ rel: 'nofollow' }} />
        <Link
          content="Inte medlem? Skapa konto här"
          href={signUpUrl}
          options={{ className: 'text-body-sm sm:text-body-md text-cherry-blossom-500 underline' }}
        />
      </dialog>
    ) : (
      {
        caption: 'Medlemmar får mer – spara artiklar, tävla med korsord och obegränsad läsning.',
        headline,
      }
    ),
  });

  return <StandaloneContentLock {...mergeProps({ content }, props)} />;
};
